// gimme: conversations-inbox-ui 06/10/2020 24a2e66917cc934433dd111db7e06fd02943ca6a
import UIButton from 'UIComponents/button/UIButton';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ThreadHistoryError = () => {
  return /*#__PURE__*/_jsxs(ErrorMessage, {
    title: I18n.text('conversations-thread-view.threadHistory.error.title'),
    illustration: "no-conversations",
    illustrationProps: {
      width: '100'
    },
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "conversations-thread-view.threadHistory.error.description"
      })
    }), /*#__PURE__*/_jsx(UIButton, {
      use: "tertiary",
      size: "xs",
      onClick: () => window.location.reload(),
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "conversations-thread-view.threadHistory.error.button"
      })
    })]
  });
};
ThreadHistoryError.displayName = 'ThreadHistoryError';
export default ThreadHistoryError;